import {
  CircularProgress,
  FormControlLabel,
  Switch,
  withWidth,
} from "@material-ui/core";
import React from "react";
import { createConfirmation } from "react-confirm";
import confirmable from "react-confirm/lib/confirmable";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import { Modal, ModalBody } from "reactstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import CategoryService from "../../../Services/Category/CategoryService";
import WYSIWYGEditor from "../../../components/InputTextareaEditor/WYSIWYG";

import boldIcon from "../../../assets/icons/toolbar/bold.svg";
import italicIcon from "../../../assets/icons/toolbar/italic.svg";
import underlineIcon from "../../../assets/icons/toolbar/underline.svg";
import alignLeftIcon from "../../../assets/icons/toolbar/align-left.svg";
import alignCenterIcon from "../../../assets/icons/toolbar/align-center.svg";
import alignRightIcon from "../../../assets/icons/toolbar/align-right.svg";
import alignJustifyIcon from "../../../assets/icons/toolbar/align-justify.svg";
import listBulletedIcon from "../../../assets/icons/toolbar/list-bulleted.svg";
import listNumberedIcon from "../../../assets/icons/toolbar/list-numbered.svg";
import { css, cx } from "emotion";
import SelectSearchBootstrap from "../../../components/InputSelectSearch/SelectSearchBootstrap";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { formatDB } from "../../../components/Utils/Currency";
import ImageUploader from "../../../components/ImageUploader";
import ProductStore from "../../../Store/ProductStore";

const user = JSON.parse(localStorage.getItem("user")) || "";
const NewForm = (props) => {
  const maxPhoto = 5;
  const { width, data, cancel, title } = props;
  const [productState, productActions] = ProductStore();
  const [state, setState] = React.useState({
    formData: {
      id: "",
      name: "",
      product_code: "",
      description: "",
      price: "",
      discounted_price: "",
      stock: "",
      max_qty: "",
      category: "",
      tenant: JSON.parse(localStorage.getItem("user")).tenant,
      image_urls: [],
      main_image: "",
      weight: "",
      dimension_length: "",
      dimension_width: "",
      dimension_height: "",
    },
  });
  console.log(state.formData);
  const [loading, setLoading] = React.useState(false);
  const [optionsCategory, setOptionsCategory] = React.useState([]);
  const [optionsCategoryShopFront, setOptionsCategoryShopFront] =
    React.useState([]);
  const [discount, setDiscount] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(true);

  const refDescription = React.createRef();
  const refCategory = React.createRef();
  const refCategoryShopfront = React.createRef();

  const numberMask = (allowDecimal) => {
    return createNumberMask({
      prefix: "",
      sufix: "",
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ".",
      allowDecimal: allowDecimal,
      decimalSymbol: ",",
    });
  };

  const handleToggle = () => {
    setState({
      formData: {
        id: "",
        name: "",
        product_code: "",
        description: "",
        price: "",
        discounted_price: "",
        stock: "",
        category: "",
        shopfront: "",
        tenant: JSON.parse(localStorage.getItem("user")).tenant,
        image_urls: [],
        main_image: "",
        weight: "",
        dimension_length: "",
        dimension_width: "",
        dimension_height: "",
      },
    });
    setOpenDialog(!openDialog);
  };

  const remapImageUrls = (data) => {
    if (data.length < maxPhoto) {
      for (let index = data.length + 1; index <= maxPhoto; index++) {
        data[index] = "";
      }
    }

    return data?.map((value, index) => {
      return {
        image: value,
      };
    });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "image_urls",
    }
  );

  const watchFields = watch();

  const onSubmit = (data) => {
    const { formData } = state;
    console.log(data);
    let image_urls = data.image_urls.map((value) => {
      return value["image"];
    });

    image_urls = image_urls.filter((value) => {
      return value;
    });

    const params = {
      id: formData?.id,
      name: data.name,
      product_code: data.product_code,
      description: data.description,
      price: formatDB(data.price),
      discounted_price: formatDB(data.discounted_price || 0),
      stock: formatDB(data.stock),
      max_qty: formatDB(data.max_qty),
      shopfront: { id: data.shopfront },
      master_category: { id: data.category },
      tenant: JSON.parse(localStorage.getItem("user")).tenant,
      image_urls: image_urls,
      main_image: data.main_image || data.image_urls[0],
      weight: formatDB(data.weight),
      dimension_length:
        data.dimension_length !== "" ? formatDB(data.dimension_length) : 0,
      dimension_width:
        data.dimension_width !== "" ? formatDB(data.dimension_length) : 0,
      dimension_height:
        data.dimension_height !== "" ? formatDB(data.dimension_length) : 0,
    };
    console.log(params);
    console.log("<<<<s");
    if (props.data === null) {
      productActions
        .store(params)
        .then(() => {
          handleToggle();
          cancel();
        })
        .catch(() => {
          handleToggle();
          cancel();
        });
    } else {
      productActions
        .put(params.id, params)
        .then(() => {
          handleToggle();
          cancel();
        })
        .catch(() => {
          handleToggle();
          cancel();
        });
    }
  };

  const pushProductImage = (value, key) => {
    const { formData } = state;
    formData["image_urls"][key] = value;
    setValue(`image_urls[${key}]`, {
      image: value,
    });
    setState({ formData });
  };

  const removeProductImage = (key) => {
    const { formData } = state;
    formData["image_urls"][key] = "";
    setValue(`image_urls[${key}]`, {
      image: "",
    });
    setState({ formData });
  };

  const asyncGetOptionsCategory = (query) => {
    // console.log(query);
    // console.log("+++++");
    return new Promise((resolve, reject) => {
      CategoryService.getDataShopfront({
        type: "product",
        tenant_id:
          user?.type === "tenant"
            ? user?.tenant?.id
            : state.formData.tenant
            ? state.formData.tenant
            : 0,
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsCategory(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const asyncGetOptionsCategoryShopfront = (query) => {
    return new Promise((resolve, reject) => {
      CategoryService.getData({
        type: "product",
        tenant_id:
          user?.type === "tenant"
            ? user?.tenant?.id
            : state.formData.tenant
            ? state.formData.tenant
            : 0,
        // keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsCategoryShopFront(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const loadRelationData = () => {
    setLoading(true);

    const categoryName = data ? data?.category?.name : "";
    Promise.all([asyncGetOptionsCategory(categoryName)]).then(() => {
      setLoading(false);
    });
    const categoryNameShopfront = data ? data?.category?.name : "";
    Promise.all([asyncGetOptionsCategoryShopfront(categoryNameShopfront)]).then(
      () => {
        setLoading(false);
      }
    );
  };

  React.useEffect(() => {
    loadRelationData();
    if (data) {
      const formData = {
        id: data?.id || "",
        name: data?.name || "",
        product_code: data?.product_code || "",
        price: data?.price?.value?.toString() || "",
        discounted_price: data?.discounted_price || "",
        stock: data?.stock || "",
        max_qty: data?.max_qty || "",
        category: data?.product_type_id || "",
        shopfront: data?.category?.id || "",
        tenant: JSON.parse(localStorage.getItem("user")).tenant,
        description: data?.description || "",
        image_urls: data?.image_urls ? data?.image_urls : [],
        main_image: data?.main_image
          ? data?.main_image
          : data?.image_urls[0] || "",
        weight: data?.weight || "",
        dimension_length: data?.dimension?.length || "",
        dimension_width: data?.dimension?.width || "",
        dimension_height: data?.dimension?.height || "",
      };
      setState({ formData });
      if (data.discounted_price > 0) {
        setDiscount(true);
      }

      reset({
        id: data?.id || "",
        name: data?.name || "",
        product_code: data?.product_code || "",
        price: data?.price?.value?.toString() || "",
        discounted_price: data?.discounted_price || "",
        stock: data?.stock || "",
        max_qty: data?.max_qty || "",
        category: data?.product_type_id || "",
        shopfront: data?.category?.id || "",
        tenant: JSON.parse(localStorage.getItem("user")).tenant,
        description: data?.description || "",
        image_urls: data?.image_urls ? remapImageUrls(data?.image_urls) : [],
        main_image: data?.main_image
          ? data?.main_image
          : data?.image_urls[0] || "",
        weight: data?.weight || "",
        dimension_length: data?.dimension?.length || "",
        dimension_width: data?.dimension?.width || "",
        dimension_height: data?.dimension?.height || "",
      });
    } else {
      reset(state?.formData);
    }
  }, [data]);

  return (
    <Modal
      isOpen={openDialog}
      toggle={handleToggle}
      backdrop={false}
      centered={true}
      size="lg"
      zIndex={1300}
      modalClassName={css`
        max-height: 100%;
        overflow-y: scroll !important;
        background: rgba(0, 0, 0, 0.7);
      `}
      contentClassName={css`
        background: none !important;
        border: none !important;
      `}
    >
      {loading && (
        <ModalBody>
          <div className="card border-0 rounded-8px">
            <div className="card-body p-4">
              <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                <CircularProgress />
                <span className="font-16 text-muted mt-3">
                  Preparing form ...
                </span>
              </div>
            </div>
          </div>
        </ModalBody>
      )}
      {!loading && (
        <ModalBody>
          <div className="card border-0 rounded-8px">
            <div
              className="card-header bg-white p-4 border-bottom-1-secondary"
              style={{ borderRadius: 8 }}
            >
              <div className="d-flex w-100 justify-content-between align-items-center">
                <h2 className="font-bold font-20 text-uppercase">
                  {title || "Product"}
                </h2>
                <span onClick={handleToggle} className="cursor-pointer">
                  <CloseIcon />
                </span>
              </div>
            </div>
            <div className="card-body p-4">
              <h3 className="font-bold font-16 text-blue mb-4">
                Basic Information
              </h3>
              <div className="form-group mb-4">
                <label
                  htmlFor="name"
                  className="font-12 font-bold d-flex justify-content-between align-items-center"
                >
                  <span>* Add Title</span>
                  <span className="font-bold text-muted">
                    {watchFields["name"]?.length || 0} / 255
                  </span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control rounded-8px"
                  {...register("name", {
                    required: "Please input product title",
                    maxLength: {
                      value: 255,
                      message: "Maximum character 255",
                    },
                  })}
                />
                {errors.name && (
                  <small className="form-text text-error">
                    {errors?.name?.message}
                  </small>
                )}
              </div>
              <div className="form-group mb-4">
                <label
                  htmlFor="description"
                  className="font-12 font-bold d-flex justify-content-between align-items-center"
                >
                  <span>Description</span>
                  <span className="font-bold text-muted">
                    {watchFields["description"]?.length || 0} / 2000
                  </span>
                </label>
                <Controller
                  id="description"
                  name="description"
                  control={control}
                  rules={{
                    maxLength: {
                      value: 2000,
                      message: "Maximum character 2000",
                    },
                  }}
                  render={({ field }) => (
                    <WYSIWYGEditor
                      {...field}
                      ref={refDescription}
                      defaultEditorContent={state?.formData?.description}
                      toolbar={{
                        options: ["blockType", "inline", "textAlign", "list"],
                        blockType: {
                          inDropdown: true,
                          options: [
                            "Normal",
                            "H1",
                            "H2",
                            "H3",
                            "H4",
                            "H5",
                            "H6",
                          ],
                        },
                        inline: {
                          inDropdown: false,
                          options: ["bold", "italic", "underline"],
                          bold: { icon: boldIcon },
                          italic: { icon: italicIcon },
                          underline: { icon: underlineIcon },
                        },
                        textAlign: {
                          inDropdown: false,
                          className: undefined,
                          component: undefined,
                          dropdownClassName: undefined,
                          options: ["left", "center", "right", "justify"],
                          left: { icon: alignLeftIcon },
                          center: { icon: alignCenterIcon },
                          right: { icon: alignRightIcon },
                          justify: { icon: alignJustifyIcon },
                        },
                        list: {
                          inDropdown: false,
                          options: ["unordered", "ordered"],
                          unordered: { icon: listBulletedIcon },
                          ordered: { icon: listNumberedIcon },
                        },
                      }}
                    />
                  )}
                />
                {errors.description && (
                  <small className="form-text text-error">
                    {errors?.description?.message}
                  </small>
                )}
              </div>
              <div className="form-group mb-4">
                <label
                  htmlFor="category"
                  className="font-12 font-bold d-flex justify-content-between align-items-center"
                >
                  <span>* Select ShopFront</span>
                </label>
                <Controller
                  name="shopfront"
                  control={control}
                  render={({ field }) => (
                    <SelectSearchBootstrap
                      {...field}
                      ref={refCategoryShopfront}
                      options={optionsCategoryShopFront}
                      getOptions={(query) =>
                        asyncGetOptionsCategoryShopfront(query)
                      }
                      search
                      closeOnSelect={true}
                      placeholder="Search for ShopFront"
                    />
                  )}
                  rules={{
                    required: "Please select ShopFront",
                  }}
                />
                {errors.category && (
                  <small className="form-text text-error">
                    {errors?.category?.message}
                  </small>
                )}
              </div>
              <div className="form-group mb-4">
                <label
                  htmlFor="category"
                  className="font-12 font-bold d-flex justify-content-between align-items-center"
                >
                  <span>* Select Category</span>
                </label>
                <Controller
                  name="category"
                  control={control}
                  render={({ field }) => (
                    <SelectSearchBootstrap
                      {...field}
                      ref={refCategory}
                      options={optionsCategory}
                      getOptions={(query) => asyncGetOptionsCategory(query)}
                      search
                      closeOnSelect={true}
                      placeholder="Search for Category"
                    />
                  )}
                  rules={{
                    required: "Please select Category",
                  }}
                />

                {errors.shopFront && (
                  <small className="form-text text-error">
                    {errors?.shopFront?.message}
                  </small>
                )}
              </div>
            </div>
          </div>
          <div className="card border-0 rounded-8px mt-3">
            <div className="card-body p-4">
              <h3 className="font-bold font-16 text-blue mb-4">
                Inventory and Pricing
              </h3>
              <div className="row">
                <div className="col-sm-4 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="product_code"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Product Code</span>
                    </label>
                    <input
                      type="text"
                      id="product_code"
                      name="product_code"
                      className="form-control rounded-8px"
                      {...register("product_code", {
                        maxLength: {
                          value: 50,
                          message: "Maximum character 50",
                        },
                      })}
                    />
                    {errors.product_code && (
                      <small className="form-text text-error">
                        {errors?.product_code?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-sm-4 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="stock"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>*Stock</span>
                    </label>
                    <Controller
                      render={({ field }) => (
                        <MaskedInput
                          {...field}
                          mask={numberMask(false)}
                          className="form-control rounded-8px"
                        />
                      )}
                      name="stock"
                      control={control}
                      rules={{
                        required: "Please input stock",
                        validate: (stock) => {
                          if (parseFloat(formatDB(stock)) <= 0) {
                            return "Stock must greater than 0";
                          }
                          return true;
                        },
                      }}
                    />
                    {errors.stock && (
                      <small className="form-text text-error">
                        {errors?.stock?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-sm-4 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="stock"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>*Max Purchase Item</span>
                    </label>
                    <Controller
                      render={({ field }) => (
                        <MaskedInput
                          {...field}
                          mask={numberMask(false)}
                          className="form-control rounded-8px"
                        />
                      )}
                      name="max_qty"
                      control={control}
                      rules={{
                        required: "Please input max purchase item",
                        validate: (max_qty) => {
                          if (parseFloat(formatDB(max_qty)) <= 0) {
                            return "Max Purchase Item must greater than 0";
                          }
                          return true;
                        },
                      }}
                    />
                    {errors.max_qty && (
                      <small className="form-text text-error">
                        {errors?.max_qty?.message}
                      </small>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="price"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>*Price</span>
                    </label>
                    <Controller
                      render={({ field }) => (
                        <MaskedInput
                          {...field}
                          mask={numberMask(false)}
                          className="form-control rounded-8px"
                        />
                      )}
                      name="price"
                      control={control}
                      rules={{
                        required: "Please input price",
                        validate: (price) => {
                          if (parseFloat(formatDB(price || 0)) <= 0) {
                            return "Price must greater than 0";
                          }
                          return true;
                        },
                      }}
                    />
                    {errors.price && (
                      <small className="form-text text-error">
                        {errors?.price?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-12 d-flex flex-column justify-content-center align-items-start">
                  <div className="form-group mb-0">
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={discount}
                          color="primary"
                          name="discount"
                          onChange={(e) => {
                            if (discount) {
                              let { formData } = state;
                              formData.discounted_price = "";
                              setState({ formData });
                            }
                            setDiscount(!discount);
                          }}
                        />
                      }
                      label={
                        <span className="font-12">Add Discount Price</span>
                      }
                      style={{ marginBottom: 0, marginLeft: 0 }}
                    />
                  </div>
                </div>
                {discount && (
                  <div className="col-sm-6 col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="price"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Discounted Price</span>
                      </label>
                      <Controller
                        render={({ field }) => (
                          <MaskedInput
                            {...field}
                            mask={numberMask(false)}
                            className="form-control rounded-8px"
                          />
                        )}
                        name="discounted_price"
                        control={control}
                        rules={{
                          required: "Please input discounted price",
                          validate: (discounted_price) => {
                            if (
                              parseFloat(formatDB(discounted_price || 0)) <= 0
                            ) {
                              return "Discounted Price must greater than 0";
                            } else if (
                              parseFloat(formatDB(discounted_price || 0)) >=
                              parseFloat(formatDB(watchFields["price"] || 0))
                            ) {
                              return (
                                "Discounted Price must less than Price " +
                                parseFloat(formatDB(watchFields["price"] || 0))
                              );
                            }
                            return true;
                          },
                        }}
                      />
                      {errors.discounted_price && (
                        <small className="form-text text-error">
                          {errors?.discounted_price?.message}
                        </small>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="card border-0 rounded-8px mt-3">
            <div className="card-body p-4">
              <h3 className="font-bold font-16 text-blue mb-4">Graphic</h3>
              <div className="form-group mb-4">
                <label className="font-12 font-bold mb-0">Main Photo</label>
                <span className="d-block font-10 text-gray-757575">
                  The recommended media file is 13:16 in size, max 0,5 Mb
                </span>
                <div className="mr-3 my-3 d-inline-block">
                  <Controller
                    render={({ field }) => (
                      <ImageUploader
                        {...field}
                        image={watchFields["main_image"] || ""}
                        footerNote="*Main Photo"
                        errorNote={
                          errors?.main_image
                            ? errors?.main_image?.message || ""
                            : ""
                        }
                        maxSize={512}
                        aspectRation={13 / 16}
                        onUploadDone={(value) => setValue(`main_image`, value)}
                        onRemove={() => setValue(`main_image`, "")}
                      />
                    )}
                    name={`main_image`}
                    control={control}
                    rules={{
                      required: "Please upload Main Photo",
                    }}
                    // defaultValue={state.formData.main_image || ""}
                  />
                </div>
              </div>
              <div className="form-group mb-4">
                <label className="font-12 font-bold mb-0">Gallerys</label>
                <span className="d-block font-10 text-gray-757575">
                  The recommended media file is 13:16 in size, max 0,5Mb. Max. 5
                  photo
                </span>
                <div className="d-flex justify-content-start align-items-start">
                  {Array.from(new Array(5)).map((val, key) => {
                    return (
                      <div className="mr-3 my-3 d-inline-block" key={key}>
                        <Controller
                          render={({ field }) => (
                            <ImageUploader
                              {...field}
                              image={state.formData.image_urls[key] || ""}
                              footerNote={`Photo ${key + 1}`}
                              maxSize={512}
                              aspectRation={13 / 16}
                              onUploadDone={(value) =>
                                pushProductImage(value, key)
                              }
                              onRemove={() => removeProductImage(key)}
                              defaultValue={
                                state.formData.image_urls[key] || ""
                              }
                            />
                          )}
                          name={`image_urls[${key}].image`}
                          control={control}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="card border-0 rounded-8px mt-3">
            <div className="card-body p-4">
              <h3 className="font-bold font-16 text-blue mb-4">Shipping</h3>
              <div className="row">
                <div className="col-sm-8 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="price"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>*Weight (gr)</span>
                    </label>
                    <Controller
                      render={({ field }) => (
                        <MaskedInput
                          {...field}
                          mask={numberMask(true)}
                          className="form-control rounded-8px"
                        />
                      )}
                      name="weight"
                      control={control}
                      rules={{
                        required: "Please input weight",
                        validate: (weight) => {
                          if (parseFloat(formatDB(weight || 0)) <= 0) {
                            return "Weight must greater than 0";
                          }
                          return true;
                        },
                      }}
                    />
                    {errors.weight && (
                      <small className="form-text text-error">
                        {errors?.weight?.message}
                      </small>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-8 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="price"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Product Size (cm)</span>
                    </label>
                    <div className="row">
                      <div className="col-4">
                        <Controller
                          render={({ field }) => (
                            <MaskedInput
                              {...field}
                              mask={numberMask(true)}
                              className="form-control rounded-8px"
                              placeholder="L"
                            />
                          )}
                          name="dimension_length"
                          control={control}
                          rules={{
                            validate: (value) => {
                              if (
                                value !== "" &&
                                parseFloat(formatDB(value)) <= 0
                              ) {
                                return "Length must greater than 0";
                              }
                              return true;
                            },
                          }}
                        />
                        {errors.dimension_length && (
                          <small className="form-text text-error">
                            {errors?.dimension_length?.message}
                          </small>
                        )}
                      </div>
                      <div className="col-4">
                        <Controller
                          render={({ field }) => (
                            <MaskedInput
                              {...field}
                              mask={numberMask(true)}
                              className="form-control rounded-8px"
                              placeholder="W"
                            />
                          )}
                          name="dimension_width"
                          control={control}
                          rules={{
                            validate: (value) => {
                              if (
                                value !== "" &&
                                parseFloat(formatDB(value)) <= 0
                              ) {
                                return "Width must greater than 0";
                              }
                              return true;
                            },
                          }}
                        />
                        {errors.dimension_width && (
                          <small className="form-text text-error">
                            {errors?.dimension_width?.message}
                          </small>
                        )}
                      </div>
                      <div className="col-4">
                        <Controller
                          render={({ field }) => (
                            <MaskedInput
                              {...field}
                              mask={numberMask(true)}
                              className="form-control rounded-8px"
                              placeholder="H"
                            />
                          )}
                          name="dimension_height"
                          control={control}
                          rules={{
                            validate: (value) => {
                              if (
                                value !== "" &&
                                parseFloat(formatDB(value)) <= 0
                              ) {
                                return "Height must greater than 0";
                              }
                              return true;
                            },
                          }}
                        />
                        {errors.dimension_height && (
                          <small className="form-text text-error">
                            {errors?.dimension_height?.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={cx(
              css`
                background: none !important;
              `,
              "card border-0 rounded-8px mt-3"
            )}
          >
            <div className="card-body py-2 px-0">
              <form onSubmit={handleSubmit(onSubmit)}>
                {!productState.isSaving && (
                  <div className="form-group text-right">
                    <button
                      type="button"
                      className={cx(
                        css`
                          padding: 14px 32px;
                          color: #bdbdbd !important;
                          background: none !important;
                        `,
                        "btn btn-md border-0 font-12 font-bold mr-3"
                      )}
                      onClick={handleToggle}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className={cx(
                        css`
                          background-color: #bbdefb !important;
                          color: #2196f3 !important;
                          padding: 14px 32px;
                        `,
                        "btn btn-md border-0 font-12 font-bold rounded-8px"
                      )}
                    >
                      {props.data ? "UPDATE" : "CREATE"}
                    </button>
                  </div>
                )}

                {productState.isSaving && (
                  <div className="w-100 d-flex justify-content-end align-items-center">
                    <CircularProgress size="1rem" />{" "}
                    <span className="ml-2 font-bold text-white">Menyimpan</span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </ModalBody>
      )}
    </Modal>
  );
};

NewForm.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function productForm(title, data, options = {}) {
  return createConfirmation(confirmable(withWidth()(NewForm)))({
    title,
    data,
    ...options,
  });
}
